"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var yup_1 = require("yup");
var formik_1 = require("formik");
var FormInner_1 = __importDefault(require("./components/FormInner"));
var Legend_1 = __importDefault(require("./components/Legend"));
var Group_1 = __importDefault(require("./components/Group"));
var Repeatable_1 = __importDefault(require("./components/Repeatable"));
var Peek_1 = __importDefault(require("./components/Peek"));
var Message_1 = __importDefault(require("./components/Message"));
var Row_1 = __importDefault(require("./components/Row"));
var Rows_1 = __importDefault(require("./components/Rows"));
var Split_1 = __importDefault(require("./components/Split"));
function Form(_a) {
    var name = _a.name, initialValues = _a.initialValues, validationSchema = _a.validationSchema, onSubmit = _a.onSubmit, _b = _a.submitButtonText, submitButtonText = _b === void 0 ? 'Submit' : _b, _c = _a.submitButtonAlign, submitButtonAlign = _c === void 0 ? 'left' : _c, _d = _a.submitButtonIsCustom, submitButtonIsCustom = _d === void 0 ? false : _d, children = _a.children, maxWidth = _a.maxWidth, spacing = _a.spacing, commonProps = __rest(_a, ["name", "initialValues", "validationSchema", "onSubmit", "submitButtonText", "submitButtonAlign", "submitButtonIsCustom", "children", "maxWidth", "spacing"]);
    return (react_1.default.createElement(formik_1.Formik, __assign({ "data-component-name": "Form" }, commonProps, { initialValues: __assign({ __name: name }, initialValues), validationSchema: validationSchema && (0, yup_1.object)(validationSchema), onSubmit: onSubmit, enableReinitialize: true }),
        react_1.default.createElement(formik_1.Form, null,
            react_1.default.createElement(FormInner_1.default, { submitButtonText: submitButtonText, submitButtonAlign: submitButtonAlign, submitButtonIsCustom: submitButtonIsCustom, maxWidth: maxWidth, spacing: spacing }, children))));
}
Form.Legend = Legend_1.default;
Form.Group = Group_1.default;
Form.Row = Row_1.default;
Form.Rows = Rows_1.default;
Form.Message = Message_1.default;
Form.Split = Split_1.default;
Form.Repeatable = Repeatable_1.default;
Form.Peek = Peek_1.default;
exports.default = Form;
